export default "__VITE_ASSET__04e442f8__"